import React, { useState } from 'react';
import { Form } from '@unform/web';
import { useHistory, useLocation } from 'react-router-dom';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import authApi from '../../services/authApi';

import Input from '../../components/InputUnform';
import Button from '../../components/Button';

function getResetErrorMessage(error) {
  const response = error?.response?.data;
  const errors = response?.result?.errors;

  if (typeof errors === 'string' && errors) {
    return errors;
  }

  if (errors?.message) {
    return errors.message;
  }

  if (response?.result?.message) {
    return response.result.message;
  }

  if (response?.message) {
    return response.message;
  }

  return 'Algo deu errado, tente novamente mais tarde.';
}

export default function ResetPassword() {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get('token');

  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSucceed, setIsSucceed] = useState(false);
  const [msgError, setMsgError] = useState('');

  async function changePassword(password, confirmedPassword) {
    setLoading(true);
    setIsError(false);
    setMsgError('');

    try {
      const response = await authApi.post('user/reset-password', {
        resetPasswordToken: token,
        newPassword: password,
        confirmNewPassword: confirmedPassword,
      });

      // auth-api responde 204 No Content em caso de sucesso
      if (response.status >= 200 && response.status < 300) {
        setIsSucceed(true);
        setTimeout(() => {
          history.push('/login');
        }, 3000);
        return;
      }

      setIsError(true);
      setMsgError('Algo deu errado, tente novamente mais tarde.');
    } catch (ex) {
      setIsError(true);
      setMsgError(getResetErrorMessage(ex));
    } finally {
      setLoading(false);
    }
  }

  function validatePassword(password, confirmedPassword) {
    if (!password) {
      return { msgError: 'Por favor, digite uma senha', valid: false };
    }

    if (!confirmedPassword) {
      return { msgError: 'Por favor, confirme sua senha', valid: false };
    }

    if (password !== confirmedPassword) {
      return { msgError: 'Senhas não conferem', valid: false };
    }

    if (password.length < 6) {
      return { msgError: 'Senha precisa ter mais que 6 digitos', valid: false };
    }

    return { valid: true };
  }

  function handleSubmit(data) {
    const { password, confirmedPassword } = data;
    const validObj = validatePassword(password, confirmedPassword);

    if (validObj.valid) {
      changePassword(password, confirmedPassword);
    } else {
      setIsError(true);
      setMsgError(validObj.msgError);
    }
  }

  if (!token) {
    return (
      <Col className="text-center p-4">
        <Alert variant="danger">
          Token inválido, por favor cheque o link e tente novamente.
        </Alert>
        <Button type="button" onClick={() => history.push('/login')}>
          Voltar para o login
        </Button>
      </Col>
    );
  }

  return (
    <Form onSubmit={form => handleSubmit(form)}>
      <Input
        label="Alteração de senha"
        name="password"
        placeholder="Sua nova senha"
        type="password"
        autoFocus
      />
      <Input
        style={{ marginTop: '10px' }}
        name="confirmedPassword"
        placeholder="Confirme sua nova senha"
        type="password"
      />

      <Col style={{ paddingTop: '20px' }}>
        {isError && <Alert variant="danger">{msgError}</Alert>}
        {isSucceed && (
          <Alert variant="success">Senha alterada com sucesso !</Alert>
        )}
      </Col>

      <Row className="mt-2 justify-content-center">
        <Button loading={loading} type="submit" disabled={isSucceed}>
          Alterar Senha
        </Button>
      </Row>
    </Form>
  );
}
